import { api } from "../../services/api";

export async function fetchMeds({
  paginaAtual,
  itensPorPagina,
  id = null,
  id_transacao = null
}) {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.get("/infrac", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      params: {
        page: paginaAtual,
        limit: itensPorPagina,
        id: id || null,
        id_transacao: id_transacao || null
      }
    });

    const data = response.data;
    console.log("API response:", data);

    return {
      dados: data || []
    };
  } catch (error) {
    throw error?.response?.data || error;
  }
}
